import React from "react";
import { Link } from "react-router-dom";

export default function LandingPage({ authenticated = false }) {
  return (
    <main className={`landing-shell ${authenticated ? "landing-shell-app" : ""}`}>
      <section className="landing-wrap">
        <section className="landing-hero">
          <div className="landing-copy">
            <p className="landing-eyebrow">AI Consulting Operations Portal</p>
            <h1>Run Niche, High-Impact Delivery Tools In One Strategic Platform</h1>
            <p>
              Move from scattered notes to structured execution. Use dedicated tools for WordPress assessments,
              research and ideation, and problem-roadblock operations with shared global controls.
            </p>
            <div className="landing-cta">
              {authenticated ? (
                <>
                  <Link to="/dashboard" className="button-link">Open Global Dashboard</Link>
                  <Link to="/tools/wpa" className="button-link ghost">Enter WordPress Tool</Link>
                </>
              ) : (
                <Link to="/login" className="button-link">Proceed to Login</Link>
              )}
              <span>{authenticated ? "You are signed in. Use the global menu to switch tools anytime." : "Single-user mode is currently enabled for this environment."}</span>
            </div>
            <div className="landing-metrics">
              <article><strong>3+</strong><span>Dedicated Tool Tracks</span></article>
              <article><strong>1</strong><span>Unified Global Control Layer</span></article>
              <article><strong>100%</strong><span>Context-Aware Workspaces</span></article>
            </div>
          </div>

          <div className="landing-panel">
            <div className="landing-panel-head">
              <h3>Portal Strategy</h3>
              <span className="landing-panel-chip">Navigation Blueprint</span>
            </div>

            <div className="strategy-grid">
              <article className="strategy-item">
                <span className="strategy-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                </span>
                <p>Global menus apply across all tools and stay consistent.</p>
              </article>
              <article className="strategy-item">
                <span className="strategy-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M4 4h8v8H4zM14 4h6v16h-6zM4 14h8v6H4z" />
                  </svg>
                </span>
                <p>Right-side contextual navigation changes by selected workspace.</p>
              </article>
              <article className="strategy-item">
                <span className="strategy-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M14 6l6 6-6 6M20 12H8M8 4v16" />
                  </svg>
                </span>
                <p>Exit navigation is always available from active tool interfaces.</p>
              </article>
              <article className="strategy-item">
                <span className="strategy-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M4 12h7l2-3 3 6 2-3h2" />
                  </svg>
                </span>
                <p>Each tool supports focused, niche problem-solving workflows.</p>
              </article>
            </div>

            <div className="landing-principle-card">
              <small>Design Principle</small>
              <p>
                Reduce decision friction with role-aware navigation and scoped interfaces while keeping platform-level control always visible.
              </p>
            </div>
          </div>

          <section className="landing-cards">
            <article className="landing-card">
              <h4>WordPress Assessment</h4>
              <p>Website-scoped questionnaire, incident tracking, preview, and report generation for technical due diligence.</p>
            </article>
            <article className="landing-card">
              <h4>Research and Ideation</h4>
              <p>Capture interview insights, map opportunities, and convert themes into validated experiment tracks.</p>
            </article>
            <article className="landing-card">
              <h4>Problem and Roadblocks</h4>
              <p>Track blockers, dependencies, owners, and escalation paths with operational clarity.</p>
            </article>
          </section>

          <section className="landing-flow">
            <h3>Operating Model</h3>
            <div className="flow-grid">
              <article><span>01</span><h5>Select Tool</h5><p>Choose a niche tool from global navigation based on problem context.</p></article>
              <article><span>02</span><h5>Set Scope</h5><p>Pick workspace scope (for example website) using guided selectors.</p></article>
              <article><span>03</span><h5>Execute</h5><p>Run tool-specific workflows with right-side contextual navigation.</p></article>
              <article><span>04</span><h5>Exit + Switch</h5><p>Return to global layer and continue with another tool seamlessly.</p></article>
            </div>
          </section>
        </section>
      </section>
    </main>
  );
}
